var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.sendForm($event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "k-form__group" },
        [
          _c(
            "label",
            { staticClass: "k-form__label", attrs: { for: "login" } },
            [_vm._v("Uživatelské jméno")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.login,
                expression: "form.login"
              }
            ],
            staticClass: "k-form__input k-form__input--lg",
            attrs: { id: "login", name: "login", required: "" },
            domProps: { value: _vm.form.login },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "login", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _vm.form_errors.login
            ? _c("field-error", [_vm._v(_vm._s(_vm.form_errors.login[0]))])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "k-form__group" },
        [
          _c(
            "label",
            { staticClass: "k-form__label", attrs: { for: "password" } },
            [_vm._v("Heslo")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.password,
                expression: "form.password"
              }
            ],
            staticClass: "k-form__input k-form__input--lg",
            attrs: {
              id: "password",
              type: "password",
              name: "password",
              required: ""
            },
            domProps: { value: _vm.form.password },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "password", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _vm.form_errors.password
            ? _c("field-error", [_vm._v(_vm._s(_vm.form_errors.password[0]))])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "button",
        { staticClass: "k-btn k-btn--primary", attrs: { type: "submit" } },
        [_vm._v("\n                Přihlásit se\n            ")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }